import React, { useRef, useState } from "react";
import { Form, OverlayTrigger, Popover } from "react-bootstrap";

const WELLNESS_COLORS = [
    "#FF6B6B",
    "#FF9F43",
    "#FECA57",
    "#1DD1A1",
    "#10AC84",
    "#48DBFB",
    "#54A0FF",
    "#5F27CD",
    "#FF9FF3",
    "#F368E0",
    "#EE5A24",
    "#009432",
    "#0652DD",
    "#9980FA",
    "#833471",
    "#B33939",
];

type Props = {
    value: string;
    onChange: (color: string) => void;
    onClick?: (e: React.MouseEvent) => void;
};

export default function ColorPicker({ value, onChange, onClick }: Props) {
    const normalizedValue = value.toUpperCase();
    const [showCustom, setShowCustom] = useState(false);
    const triggerRef = useRef<HTMLButtonElement>(null);

    const popover = (
        <Popover id="color-picker-popover" style={{ zIndex: 10500 }}>
            <Popover.Body className="p-2">
                <div className="d-flex flex-wrap gap-1">
                    {WELLNESS_COLORS.map((c) => (
                        <button
                            key={c}
                            type="button"
                            onClick={() => {
                                onChange(c);
                                triggerRef.current?.click();
                            }}
                            style={{
                                width: 24,
                                height: 24,
                                borderRadius: "50%",
                                backgroundColor: c,
                                border: normalizedValue === c ? "2px solid #212529" : "2px solid transparent",
                                cursor: "pointer",
                                padding: 0,
                            }}
                            aria-label={`Выбрать цвет ${c}`}
                        />
                    ))}
                    <button
                        type="button"
                        onClick={() => setShowCustom((s) => !s)}
                        className="btn btn-sm btn-outline-secondary"
                        style={{
                            width: 24,
                            height: 24,
                            borderRadius: "50%",
                            padding: 0,
                            fontSize: 12,
                            lineHeight: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        title="Свой цвет"
                    >
                        +
                    </button>
                </div>
                {showCustom && (
                    <div className="mt-2 d-flex align-items-center gap-2">
                        <Form.Control
                            type="color"
                            value={value}
                            onChange={(e) => onChange(e.target.value)}
                            style={{ width: 40, height: 32, padding: 2 }}
                        />
                        <span className="text-muted small">{value}</span>
                    </div>
                )}
            </Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger
            trigger="click"
            placement="bottom"
            overlay={popover}
            rootClose
            container={typeof document !== "undefined" ? document.body : undefined}
            popperConfig={{ strategy: "fixed" }}
            onToggle={(nextShow) => {
                if (!nextShow) setShowCustom(false);
            }}
        >
            <button
                ref={triggerRef}
                type="button"
                onClick={onClick}
                style={{
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    backgroundColor: value,
                    border: "2px solid #dee2e6",
                    cursor: "pointer",
                    padding: 0,
                }}
                aria-label="Выбрать цвет"
            />
        </OverlayTrigger>
    );
}
